import React from "react";
import { NavLink } from "react-router-dom";
import * as IconlyPack from "react-iconly";
import FeatherIcon from "feather-icons-react";
import BusinessIcon from "@material-ui/icons/Business";
import "./NavbarAssureur.css";
var NavbarAssureur = () => {
  const [active, setActive] = React.useState("");
  React.useEffect(() => {
    if (
      window.location.pathname === "/assurance/facturation-client" ||
      window.location.pathname === "/assurance/facturation-fournisseur"
    ) {
      setActive("actived");
    } else {
      setActive("");
    }
  }, []);

  return (
    <>
      <li className="nav-item nav-item-vertical-custom">
        <NavLink
          className="nav-link nav-link-vertival-custom"
          to="/assurance/dashboard"
          activeClassName="actived"
        >
          <IconlyPack.Chart
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="hiddenable-navlink-label">Tableau de bord</span>
        </NavLink>
      </li>
      <li className="nav-item nav-item-vertical-custom">
        <NavLink
          className="nav-link nav-link-vertival-custom"
          to="/assurance/soins"
          activeClassName="actived"
        >
          {/* <IconlyPack.Scan
              set="bold"
              primaryColor="white"
              className="icon-navbar-vertical"
            /> */}
          <i
            className="fa fa-qrcode fa-lg icon-navbar-vertical"
            aria-hidden="true"
            style={{ color: "#ffffff", marginTop: "0.3rem" }}
          ></i>
          <span className="hiddenable-navlink-label">Soins</span>
        </NavLink>
      </li>
      <li className="nav-item nav-item-vertical-custom">
        <NavLink
          className="nav-link nav-link-vertival-custom"
          to="/assurance/rapports"
          activeClassName="actived"
        >
          <FeatherIcon
            strokeWidth="3"
            className="icon-navbar-vertical"
            icon="pie-chart"
            style={{ color: "#ffffff" }}
          />
          <span className="hiddenable-navlink-label">Rapports</span>
        </NavLink>
      </li>
      <li className="nav-item nav-item-vertical-custom">
        <NavLink
          className="nav-link nav-link-vertival-custom"
          to="/assurance/remboursement"
          activeClassName="actived"
        >
          {/* <IconlyPack.Document
              set="bold"
              primaryColor="white"
              className="icon-navbar-vertical"
            /> */}
          {/* <FeatherIcon
              strokeWidth="3"
              className="icon-navbar-vertical"
              icon="dollar-sign"
              style={{ color: '#ffffff' }}
            /> */}
          <i
            className="fa fa-credit-card fa-lg icon-navbar-vertical"
            style={{ color: "#ffffff", marginTop: "0.3rem" }}
            aria-hidden="true"
          ></i>
          <span className="hiddenable-navlink-label">Remboursements</span>
        </NavLink>
      </li>
      <li className="nav-item nav-item-vertical-custom">
        <NavLink
          className="nav-link nav-link-vertival-custom"
          to="/assurance/assures"
          activeClassName="actived"
        >
          <IconlyPack.People
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="hiddenable-navlink-label">Assurés</span>
        </NavLink>
      </li>
      <li className="nav-item nav-item-vertical-custom">
        <NavLink
          className="nav-link nav-link-vertival-custom"
          to="/assurance/prise-en-charge"
          activeClassName="actived"
        >
          <IconlyPack.Category
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="hiddenable-navlink-label">Prises en charge</span>
        </NavLink>
      </li>
      <li className="nav-item nav-item-vertical-custom">
        <NavLink
          className="nav-link nav-link-vertival-custom"
          to="/assurance/prestataire"
          activeClassName="actived"
        >
          <IconlyPack.AddUser
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="hiddenable-navlink-label">Prestataires</span>
        </NavLink>
      </li>
      <li className="nav-item nav-item-vertical-custom ">
        <a
          className={`nav-link nav-link-vertival-custom ${active}`}
          href="#submenu2"
          data-toggle="collapse"
          // activeClassName="actived"
        >
          <IconlyPack.Wallet
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="hiddenable-navlink-label">
            Facturation
            <i className="fas fa-caret-down" style={{ marginLeft: "10px" }}></i>
          </span>
        </a>
        <ul
          className="collapse nav flex-column ms-1"
          id="submenu2"
          data-parent="#menu"
          style={{ marginLeft: "1rem" }}
        >
          <li className="nav-item w-100">
            <NavLink
              to="/assurance/facturation-fournisseur"
              className="nav-link"
              activeClassName="actived"
            >
              <IconlyPack.ArrowRightSquare
                set="bold"
                primaryColor="white"
                className="icon-navbar-vertical"
              />
              <span className="hiddenable-navlink-label">Fournisseurs</span>
            </NavLink>
          </li>
          <li className="nav-item w-100">
            <NavLink
              to="/assurance/facturation-client"
              className="nav-link"
              activeClassName="actived"
            >
              <IconlyPack.ArrowLeftSquare
                set="bold"
                primaryColor="white"
                className="icon-navbar-vertical"
              />
              <span className="hiddenable-navlink-label">Clients</span>
            </NavLink>
          </li>
        </ul>
      </li>

      <li className="nav-item nav-item-vertical-custom">
        <NavLink
          className="nav-link nav-link-vertival-custom"
          to="/assurance/entreprise"
          activeClassName="actived"
        >
          {/* <IconlyPack.Discovery
              set="bold"
              primaryColor="white"
              className="icon-navbar-vertical"
            /> */}
          <BusinessIcon
            className="icon-navbar-vertical"
            style={{ color: "#ffffff" }}
          />
          <span className="hiddenable-navlink-label">Entreprises</span>
        </NavLink>
      </li>

      <li className="nav-item nav-item-vertical-custom">
        <NavLink
          className="nav-link nav-link-vertival-custom"
          to="/assurance/devis"
          activeClassName="actived"
        >
          <IconlyPack.Activity
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="hiddenable-navlink-label">Devis</span>
        </NavLink>
      </li>
      <li className="nav-item nav-item-vertical-custom">
        <NavLink
          className="nav-link nav-link-vertival-custom"
          to="/assurance/parametre"
          activeClassName="actived"
        >
          <IconlyPack.Setting
            set="bold"
            primaryColor="white"
            className="icon-navbar-vertical"
          />
          <span className="hiddenable-navlink-label">Paramétres</span>
        </NavLink>
      </li>
    </>
  );
};

export default NavbarAssureur;
